<rt-dropdown [width]="DropdownWidth.FullWidth" #timeDropdownContainer class="viewport">
  <rt-dropdown-item
    *ngFor="let time of timesArr; let i = index; trackBy: trackBy"
    (click)="onTimeSelect(time)"
    [highlighted]="i === selectionIndex"
    #timeItemsQuery
    class="time-dropdown-item"
  >
    <span>{{ time }}</span>
  </rt-dropdown-item>
</rt-dropdown>
